module.exports = __webpack_public_path__ + "img/id-1.0023d042.png";